import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { Row, Col } from 'antd';
import {
  StyledButton,
  ResponsiveDesktopDiv,
  ResponsiveMobileDiv
} from 'components/Styled';
import { get, join, compact, map, assign, filter } from 'lodash';

import currency from 'utils/currency';
import countriesData from 'data/countries';

const badgeStyle = {
  width: '68px',
  height: '23px',
  lineHeight: '23px',
  textAlign: 'center',
  fontSize: '12px',
  fontWeight: 700,
  color: '#f5f5f5',
  borderRadius: '5px'
};

class QuotationResult extends Component {
  state = {
    value: false
  };

  handleClick = () => {
    this.props.onClick(this.props.index);
  };

  checkUnavailable = (carrier, previewWeight, service = null) => {
    // volume control @20200806
    const isTpac = map(
      filter(
        this.props.countries,
        x => x.continent === 'South America' || x.continent === 'North America'
      ),
      'alpha-2'
    ).includes(this.props.destination);

    const isEurope = map(
      filter(this.props.countries, x => x.continent === 'Europe'),
      'alpha-2'
    ).includes(this.props.destination);

    switch (carrier) {
      case 'fedex':
      case 'tnt':
        if (isTpac && previewWeight > 299) return 'unavailable_overload_split';
        if (
          (isEurope || this.props.destination === 'AE') &&
          previewWeight > 299
        )
          return 'unavailable_overload_split';
        // if (
        //   ['AU', 'NZ'].includes(this.props.destination) &&
        //   previewWeight > 50 &&
        //   carrier === 'tnt'
        // )
        //   return 'unavailable_overload';
        // if (
        //   ['AU', 'NZ'].includes(this.props.destination) &&
        //   previewWeight > 299
        // )
        //   return 'unavailable_overload_split';
        return null;
      default:
        return null;
    }
  };

  getButtonText = () => {
    let noService = this.props.noService;
    if (
      this.props.service === 'fedex-ie' &&
      this.props.user === '5029e414-7ede-438c-b657-b8d70cb81a6e'
    ) {
      noService = false;
    }

    if (
      this.props.user === 'f4c3e5f1-bb15-4ceb-a7b2-a3ef002450a1' &&
      this.props.destination === 'IN'
    ) {
      noService = false;
    }

    if (noService) return 'quotation.no_service';

    return 'quotation.booking';
  };

  render() {
    const mdGrids = [7, 6, 11];
    const publicRate = new currency(this.props.publicRate);
    const rate = new currency(this.props.rate);
    const discount = publicRate.getDiffPercent(rate);

    const unavailableReason = this.checkUnavailable(
      this.props.carrier,
      this.props.previewWeight,
      this.props.service
    );

    const path = `/${localStorage.i18nextLng}/`;

    let noService = this.props.noService;
    if (
      this.props.service === 'fedex-ie' &&
      this.props.user === '5029e414-7ede-438c-b657-b8d70cb81a6e'
    ) {
      noService = false;
    }

    if (
      this.props.user === 'f4c3e5f1-bb15-4ceb-a7b2-a3ef002450a1' &&
      this.props.destination === 'IN'
    ) {
      noService = false;
    }

    return (
      <div
        id={this.props.service}
        style={{
          margin: this.props.index === 0 ? '10px 10px' : '15px 10px',
          backgroundColor: '#fff',
          boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.2)',
          borderRadius: '5px'
        }}>
        <ResponsiveDesktopDiv>
          <Row type="flex">
            <Col
              span={7}
              style={{
                position: 'relative',
                backgroundImage: `-webkit-image-set(url('https://spaceship-product-images.s3.ap-east-1.amazonaws.com/carrier_service_images/desktop/${this.props.service}.png') 1x, url('https://spaceship-product-images.s3.ap-east-1.amazonaws.com/carrier_service_images/desktop/${this.props.service}@2x.png') 2x, url('https://spaceship-product-images.s3.ap-east-1.amazonaws.com/carrier_service_images/desktop/${this.props.service}@3x.png') 3x)`,
                backgroundSize: 'cover',
                paddingBottom: '90px',
                backgroundPosition: '50% 50%',
                borderRadius: '5px 0 0px 5px'
              }}>
              <div
                style={{
                  ...badgeStyle,
                  position: 'absolute',
                  top: '10px',
                  left: '10px',
                  display: get(
                    this.props.promotes,
                    `${this.props.t('key')}.featured`
                  )
                    ? 'block'
                    : 'none',
                  backgroundColor: '#16B7B3'
                }}>
                {this.props.t('quotation.featured')}
              </div>
            </Col>
            <Col
              span={17}
              style={{
                padding: '16px 15px 15px'
              }}>
              <Row type="flex">
                <Col span={17}>
                  <span
                    style={{
                      fontSize: '16px',
                      fontWeight: 700
                    }}>
                    {join(
                      compact([
                        get(this.props.carrierName, this.props.t('key')),
                        get(this.props.name, this.props.t('key'))
                      ]),
                      ' '
                    )}
                  </span>
                </Col>
                <Col
                  span={7}
                  style={{
                    position: 'relative',
                    overflow: 'hidden',
                    minHeight: 0,
                    top: '-3px'
                  }}>
                  <div
                    className="origin-background"
                    style={{
                      ...badgeStyle,
                      width: '65px',
                      height: '23px',
                      lineHeight: '23px',
                      float: 'right',
                      backgroundColor: '#16B7B3',
                      opacity: discount ? 1 : 0
                    }}>
                    {discount} OFF
                  </div>
                </Col>
              </Row>
              <Row type="flex" gutter={14} align="bottom">
                <Col
                  span={mdGrids[0]}
                  style={{
                    height: '24px'
                  }}>
                  {get(this.props.description, this.props.t('key'))}
                </Col>
                <Col
                  span={mdGrids[1]}
                  style={{
                    height: '24px'
                  }}>
                  {!this.props.minDeliveryDays ? (
                    <span
                      style={{
                        fontSize: '12px',
                        color: '#2C2C2E'
                      }}>
                      {this.props.t('quotation.no_arrive_days')}
                    </span>
                  ) : (
                    <span
                      style={{
                        fontSize: '16px',
                        fontWeight: 700
                      }}>
                      {this.props.minDeliveryDays === this.props.maxDeliveryDays
                        ? `${this.props.minDeliveryDays}`
                        : `${this.props.minDeliveryDays} - ${this.props.maxDeliveryDays}`}
                    </span>
                  )}
                  {!this.props.minDeliveryDays ? null : (
                    <span
                      style={{
                        fontSize: '12px',
                        color: '#2C2C2E',
                        marginLeft: '5px'
                      }}>
                      {this.props.t('common.working_day')}
                    </span>
                  )}
                </Col>
                <Col
                  span={mdGrids[2]}
                  className="buttonSecond-color"
                  style={{
                    textAlign: 'right',
                    color: '#2C2C2E'
                  }}>
                  {this.props.publicRate && (
                    <del
                      style={{
                        color: '#2C2C2E',
                        paddingRight: '5px',
                        opacity: this.props.publicRate ? 1 : 0
                      }}>
                      <span>
                        {publicRate.format(true)}
                      </span>
                    </del>
                  )}
                  <span
                    style={{
                      fontWeight: 700,
                      fontSize: '24px'
                    }}>
                    {rate.format(true)}
                  </span>
                </Col>
              </Row>
              <Row
                type="flex"
                gutter={14}
                style={{ padding: '5px 0 10px', fontSize: '12px' }}>
                <Col span={mdGrids[0]}></Col>
                <Col span={mdGrids[1]}></Col>
                <Col span={mdGrids[2]} style={{ textAlign: 'right' }}>
                  <span style={{ color: '#2C2C2E' }}>
                    {this.props.destination === 'HK'
                      ? ''
                      : this.props.t('quotation.not_include_tax')}
                  </span>
                  <br />
                  <span
                    className="buttonSecond-color"
                    style={{ color: '#9900A5' }}>
                    {get(this.props.promotes, `${this.props.t('key')}.event`)}
                  </span>
                </Col>
              </Row>
              <Row type="flex" gutter={14}>
                <Col span={17}>
                  <Row type="flex" gutter={10}>
                    {map(this.props.attributes, (a, i) => {
                      return (
                        <Col
                          key={i}
                          style={{
                            width: '50%',
                            margin: '3px 0'
                          }}>
                          <Row type="flex">
                            <Col style={{ width: '20px' }}>
                              <img
                                src={a.url}
                                style={{ width: 'auto' }}
                                alt=""
                              />
                            </Col>
                            <Col style={{ width: 'calc(100% - 20px)' }}>
                              {a.type === 'box' &&
                              this.props.carrier === 'fedex' &&
                              !this.props.service.includes('document') ? (
                                <NavLink
                                  className="buttonTheme-color"
                                  style={{
                                    fontSize: '10px',
                                    color: '#57D7DD',
                                    fontWeight: 700,
                                    textDecoration: 'underline'
                                  }}
                                  to={`${process.env.PUBLIC_URL}${path}buy-boxes/options`}>
                                  {a.message[this.props.t('key')]}
                                </NavLink>
                              ) : (
                                <span
                                  style={{
                                    fontSize: '10px',
                                    color: '#2C2C2E'
                                  }}>
                                  {a.message[this.props.t('key')]}
                                </span>
                              )}
                            </Col>
                          </Row>
                        </Col>
                      );
                    })}
                  </Row>
                </Col>
                <Col span={7} style={{ textAlign: 'right' }}>
                  <StyledButton
                    ghost
                    type="primary"
                    style={assign(
                      {},
                      { maxWidth: '120px', height: '45px', padding: 0 },
                      unavailableReason || noService
                        ? {
                            whiteSpace: 'normal',
                            wordWrap: 'break-word',
                            lineHeight: '15px',
                            fontSize: 14
                          }
                        : {}
                    )}
                    block
                    onClick={this.handleClick}
                    disabled={unavailableReason || noService}>
                    {!unavailableReason
                      ? this.props.t(this.getButtonText())
                      : this.props.t(`quotation.${unavailableReason}`)}
                  </StyledButton>
                </Col>
              </Row>
            </Col>
          </Row>
        </ResponsiveDesktopDiv>
        <ResponsiveMobileDiv>
          <Row
            type="flex"
            style={{
              boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.2)'
            }}>
            <Col
              span={8}
              style={{
                position: 'relative',
                backgroundImage: `-webkit-image-set(url(https://spaceship-product-images.s3.ap-east-1.amazonaws.com/carrier_service_images/mobile/${this.props.service}.png) 1x, url(https://spaceship-product-images.s3.ap-east-1.amazonaws.com/carrier_service_images/mobile/${this.props.service}@2x.png) 2x, url(https://spaceship-product-images.s3.ap-east-1.amazonaws.com/carrier_service_images/mobile/${this.props.service}@3x.png) 3x)`,
                backgroundSize: 'cover',
                paddingBottom: '90px',
                backgroundPosition: '50% 50%',
                borderRadius: '5px 0 0px 0px',
                width: '140px'
              }}>
              <div
                className="buttonSecond-background"
                style={{
                  ...badgeStyle,
                  position: 'absolute',
                  top: '10px',
                  left: '10px',
                  display: get(
                    this.props.promotes,
                    `${this.props.t('key')}.featured`
                  )
                    ? 'block'
                    : 'none',
                  backgroundColor: '#16B7B3'
                }}>
                {this.props.t('quotation.featured')}
              </div>
            </Col>
            <Col
              span={16}
              style={{
                padding: '10px 15px 15px',
                flex: '1'
              }}>
              <Row type="flex" gutter={14} align="bottom">
                <Col span={24}>
                  <span
                    style={{
                      fontSize: '14px',
                      fontWeight: 700
                    }}>
                    {join(
                      compact([
                        get(this.props.carrierName, this.props.t('key')),
                        get(this.props.name, this.props.t('key'))
                      ]),
                      ' '
                    )}
                  </span>
                </Col>
              </Row>
              <Row type="flex" gutter={14} align="bottom">
                <Col
                  span={24}
                  style={{
                    margin: '5px 0'
                  }}>
                  {!this.props.minDeliveryDays ? (
                    <span
                      style={{
                        fontSize: '12px',
                        color: '#2C2C2E'
                      }}>
                      {this.props.t('quotation.no_arrive_days')}
                    </span>
                  ) : (
                    <span
                      style={{
                        fontSize: '16px',
                        fontWeight: 700
                      }}>
                      {this.props.minDeliveryDays === this.props.maxDeliveryDays
                        ? `${this.props.minDeliveryDays}`
                        : `${this.props.minDeliveryDays} - ${this.props.maxDeliveryDays}`}
                    </span>
                  )}
                  {!this.props.minDeliveryDays ? null : (
                    <span
                      style={{
                        fontSize: '12px',
                        color: '#2C2C2E',
                        marginLeft: '5px'
                      }}>
                      {this.props.t('common.working_day')}
                    </span>
                  )}
                </Col>
              </Row>
              <Row type="flex" gutter={14} align="bottom">
                <Col span={24}>
                  <div
                    className="origin-background"
                    style={{
                      ...badgeStyle,
                      float: 'right',
                      marginBottom: 0,
                      backgroundColor: '#16B7B3',
                      opacity: discount ? 1 : 0
                    }}>
                    {discount} OFF
                  </div>
                </Col>
              </Row>
              <Row type="flex" gutter={14} align="bottom">
                <Col
                  span={24}
                  style={{ paddingTop: '5px', textAlign: 'right' }}>
                  <del
                    style={{
                      color: '#2C2C2E',
                      opacity: this.props.publicRate ? 1 : 0
                    }}>
                    <span>
                      {publicRate.format(true)}
                    </span>
                  </del>
                </Col>
              </Row>
              <Row type="flex" gutter={14} style={{ fontSize: '12px' }}>
                <Col span={24} style={{ textAlign: 'right' }}>
                  <span style={{ color: '#9900A5' }}>
                    {get(
                      this.props.promotes,
                      `${this.props.t('key')}.event`
                    ) ? (
                      <React.Fragment>
                        {get(
                          this.props.promotes,
                          `${this.props.t('key')}.event`
                        )}
                        <br />
                      </React.Fragment>
                    ) : null}
                  </span>
                  <span
                    className="buttonSecond-color"
                    style={{
                      color: this.props.pickup ? '#2C2C2E' : '#2C2C2E',
                      marginLeft: '5px'
                    }}>
                    <span
                      style={{
                        fontWeight: 700,
                        fontSize: '24px'
                      }}>
                      {new currency(this.props.rate).format(true)}
                    </span>
                  </span>
                </Col>
              </Row>
              <Row type="flex" gutter={14} align="bottom">
                <Col
                  span={24}
                  style={{ paddingTop: '5px', textAlign: 'right' }}>
                  <span style={{ color: '#2C2C2E' }}>
                    {this.props.destination === 'HK'
                      ? ''
                      : this.props.t('quotation.not_include_tax')}
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row type="flex" gutter={14} style={{ padding: '15px' }}>
            <Col span={16}>
              <Row type="flex" gutter={10}>
                {map(this.props.attributes, (a, i) => {
                  return (
                    <Col
                      key={i}
                      style={{
                        width: '50%',
                        margin: '3px 0'
                      }}>
                      <Row type="flex">
                        <Col style={{ width: '20px' }}>
                          <img src={a.url} style={{ width: 'auto' }} alt="" />
                        </Col>
                        <Col style={{ width: 'calc(100% - 20px)' }}>
                          {a.type === 'box' &&
                          this.props.carrier === 'fedex' &&
                          !this.props.service.includes('document') ? (
                            <NavLink
                              style={{
                                fontSize: '10px',
                                color: '#57D7DD',
                                fontWeight: 700,
                                textDecoration: 'underline'
                              }}
                              to={`${process.env.PUBLIC_URL}${path}buy-boxes/options`}>
                              {a.message[this.props.t('key')]}
                            </NavLink>
                          ) : (
                            <span
                              style={{ fontSize: '10px', color: '#2C2C2E' }}>
                              {a.message[this.props.t('key')]}
                            </span>
                          )}
                        </Col>
                      </Row>
                    </Col>
                  );
                })}
              </Row>
            </Col>
            <Col span={8} style={{ textAlign: 'right' }}>
              <StyledButton
                type="primary"
                style={assign(
                  {},
                  { maxWidth: '120px', height: '45px', padding: 0 },
                  unavailableReason || noService
                    ? {
                        whiteSpace: 'normal',
                        wordWrap: 'break-word',
                        lineHeight: '14px',
                        fontSize: 12
                      }
                    : {}
                )}
                ghost
                block
                onClick={this.handleClick}
                disabled={unavailableReason || noService}>
                {!unavailableReason
                  ? this.props.t(this.getButtonText())
                  : this.props.t(`quotation.${unavailableReason}`)}
              </StyledButton>
            </Col>
          </Row>
        </ResponsiveMobileDiv>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.auth.user || false,
    countries: state.shipments.countries || countriesData
  };
};

export default connect(mapStateToProps)(QuotationResult);
